<template>
  <div id="Funds" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">F</span>ondos</div>
        <div class="col-3 t-r f26"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt8 pl5 pr5">
      <div class="col-12 bg-color-white r5">
        <div class="col-4 pr5 pt8 pb8">
          <div class="col-12 bg-color-white t-c r5 br1">
            <div class="col-12 f28 color-primary">{{pageData.account_points}}</div>
            <div class="col-12 f14 color-muted">Puntos</div>
          </div>
        </div>
        <div class="col-4 pl5 pr5 pt8 pb8">
          <div class="col-12 bg-color-white t-c r5 br1">
            <div class="col-12 f28 color-primary">{{pageData.lock_points}}</div>
            <div class="col-12 f14 color-muted">Bloqueado</div>
          </div>
        </div>
        <div class="col-4 pl5 pt8 pb8">
          <div class="col-12 bg-color-white t-c r5">
            <div class="col-12 f28 color-primary">{{pageData.account_credit}}</div>
            <div class="col-12 f14 color-muted">Crédito</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lh40 pl10 pr10 f14 uppercase"><span><i class="iconfont icon-arrow-right-filling color-primary"></i></span><span>Movimiento</span></div>
    <div class="col-12 pl5 pr5">
      <div class="col-12 bg-color-white r5 pl5 pr5">
        <div class="col-12 pl5 pr5 pt5 pb5 bb1" v-for="(log,log_i) in funds_log_list" v-bind:key="log_i">
          <div class="col-1 pt8"><i class="iconfont icon-jian color-danger" v-if="log.points <= 0"></i> <i class="iconfont icon-jia color-success" v-else></i></div>
          <div class="col-7">
            <div class="col-12 fw">{{log.log_type_name}}</div>
            <div class="col-12 color-muted f12">{{log.log_time}}</div>
          </div>
          <div class="col-4 t-r pt8">
            <div class="col-12">
              <span class="color-danger" v-if="log.points <= 0">{{ fun.formatMoney(log.points,2) }}</span> <span class="color-success" v-else>{{ fun.formatMoney(log.points,2) }}</span>
            </div>
            <div class="col-12 f12">
              <span class="color-danger" v-if="log.points_now <= 0">{{ fun.formatMoney(log.points_now,2) }}</span> <span class="color-success" v-else>{{ fun.formatMoney(log.points_now,2) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h5"></div>
  </div>
</template>
<script>
export default {
  name: 'Funds',
  data () {
    return {
      pageData: {},
      funds_log_list: []
    }
  },
  created: function () {
    this.get_pageData();
  },
  methods: {
    get_pageData: function () {
      this.post(this.api_url + 'Tec/account','',true).then((res)=>{
        if(res.status == 1){
          this.pageData = res.data;
          this. get_funds_log();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    get_funds_log: function () {
      this.post(this.api_url + 'Tec/funds_log','',true).then((res)=>{
        if(res.status == 1){
          this.funds_log_list = res.data;
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/My/Funds.vue